import controller from './advertisement.controller';
import templateBase from './templates/advertisement.view.html';
import templateT1 from './templates/advertisement-t1.view.html';
import templateT2 from './templates/advertisement-t2.view.html';
import templateT3 from './templates/advertisement-t3.view.html';
import templateT4 from './templates/advertisement-t4.view.html';
import templateT15 from './templates/advertisement-t15.view.html';
import templateAD from './templates/advertisement.adaptative.view.html';

let AdvertisementComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<',
        typeContent: '@',
        positions:'@',
        pageName:'@',
        contentData:'<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');
  if (__env.adaptative) {
    return templateAD;
  } else {
    if (response.CMS.component == 'template_t1') { return templateT1;}
    else if (response.CMS.component == 'template_t3'){ return templateT3; }
    else if (response.CMS.component == 'template_t2'){ return templateT2; }
    else if (response.CMS.component == 'template_t4'){ return templateT4; }
    else if (response.CMS.component == 'template_t15'){ return templateT15; }
    else {
      return templateBase;
    }
  }
}

export default AdvertisementComponent;


/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/shared/components/advertisement/advertisement.component.js
 **/